import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
import trash2Fill from '@iconify/icons-eva/trash-2-fill';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
// material
import { useTheme, experimentalStyled as styled } from '@material-ui/core/styles';
import { Box, Toolbar, Tooltip, IconButton, Typography, OutlinedInput, InputAdornment } from '@material-ui/core';
import { useNavigate } from 'react-router';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import axios from 'axios';
import { REST_API_END_POINT } from 'src/constants/Defaultvalues';
import ConfirmationPopup from '../../official-request/ConfirmationPopup';
import { PATH_DASHBOARD } from '../../../../routes/paths';

// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3)
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

// ----------------------------------------------------------------------

ProductToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func
};

export default function ProductToolbar({ numSelected, filterName, onFilterName,selected,selectedNames,onDelete,userId,isClientUserRoles }) {
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [openDeletePop,setOpenDeletePop] = useState(false);
  const userData = JSON.parse(localStorage.getItem('user'))
  const explodedPermissions =userData?.exploded_permissions
  const hasPermission =isClientUserRoles ? explodedPermissions?.some(permission => ['Delete Client User Role'].includes(permission)) : explodedPermissions?.some(permission => ['Delete User Roles'].includes(permission))

  const changeStatus = async (roleId, receivedStatus) => {
    try {
      let id = roleId;
      let status = receivedStatus;
        let response = await axios.post(`${REST_API_END_POINT}settings/delete-user-role`,
        {userRoleId:id,status:status,userId:userId});
      // console.log("response-----------------", response.data);
      return response.data;
    }
    catch (error) {
      console.log("Delete error : ", error);
    }
  }

  const handleMenuItemClick = async (selectedIds, newStatus) => {
    try{
      setOpenDeletePop(false);
      const result =await Promise.all(selectedIds.map((id) => changeStatus(id, newStatus)));
      // console.log("deleted data length",result.length);
      if (selectedIds.length === result.length){
        onDelete([])
        enqueueSnackbar(`${result.length} user roles deleted`, { variant: 'success' });
        if(isClientUserRoles){
          navigate(PATH_DASHBOARD.client.userRoles, { state: { data: result } });
        }else{
          navigate(PATH_DASHBOARD.adminAccount.userRole, { state: { data: result } });
        }
      }
      else {
        console.log("Error.........!");
        enqueueSnackbar("Unable to delete the user roles.!", { variant: 'error' });
         if(isClientUserRoles){
          navigate(PATH_DASHBOARD.client.userRoles, { state: { data: result } });
        }else{
        navigate(PATH_DASHBOARD.adminAccount.userRole, { state: { data: result } });
        }
      }
    }
    catch(error){
      console.log("Server error",error);
    }
  }

  return (
    <RootStyle
      sx={{
        ...(numSelected > 0 && {
          color: isLight ? 'primary.main' : 'text.primary',
          bgcolor: isLight ? 'var(--signwise-app-chrome-toolbar)' : 'var(--signwise-app-chrome-toolbar)'
        })
      }}
    >
      <SearchStyle
        sx={{backgroundColor:'var(--signwise-app-chrome-toolbar)'}}
          value={filterName}
          onChange={onFilterName}
          placeholder="Search User Roles..."
          startAdornment={
            <InputAdornment position="start">
              <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
            </InputAdornment>
          }
        />
      {numSelected > 0 && (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
        
      )}

      {(numSelected > 0 ) &&   (
        <Tooltip title="Delete" onClick={()=>{
          if(hasPermission){
            setOpenDeletePop(true)
          }else{
            enqueueSnackbar("Access Denied : You do not have sufficiant permission.", { variant: 'error' })
            
          }}
          }>
          <IconButton>
            <Icon icon={trash2Fill} />
          </IconButton>
        </Tooltip>
      )
      //  : (
      //   <Tooltip title="Filter list">
      //     <IconButton>
      //       <Icon icon={roundFilterList} />
      //     </IconButton>
      //   </Tooltip>
      // )
      }

      
      {/* Confirmation for deleting multiple user roles  */}
      <ConfirmationPopup
        open={openDeletePop}
        handleClose={()=>{setOpenDeletePop(false)}}
        message={`You want to delete : ${selectedNames.join(', ')} !`}
        handleClick={() => handleMenuItemClick(selected, 2)}
      />

    </RootStyle>
  );
}
